import type { NotificationRoutingProviderProps } from "./NotificationRoutingProvider";
import { NotificationRoutingContext } from "./notificationRoutingContext";

export function NotificationRoutingProvider({ children }: NotificationRoutingProviderProps) {
  return (
    <NotificationRoutingContext.Provider value={{ responseReady: true, hasPendingNotificationIntent: false }}>
      {children}
    </NotificationRoutingContext.Provider>
  );
}
